.specialCard {
  border-radius: 24px;
  border-color: var(--colors-grays-light);
  border-style: solid;
  border-width: 1px;
  overflow: hidden;
  height: 100%;
}

.specialCardInfo {
  flex-direction: column;
  padding: 16px 24px;
  color: var(--colors-info-main);
  width: 100%;
}

.specialBadge {
  color: var(--colors-info-main);
  margin-bottom: 8px;
}

.specialTitle {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  -webkit-line-clamp: 2;
}

.specialCardImg {
  display: flex;
  width: 100%;
  aspect-ratio: 2.11 / 1;
  object-fit: cover;
}

.specialCardImgArea {
  width: 100%;
  aspect-ratio: 2.11 / 1;
  align-items: center;
  display: flex;
  justify-content: center;
  background-color: var(--colors-info-main);
  color: var(--colors-text-info);
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
}

@media all and (--reefer-media-tablet-min) {
  .specialCardInfo {
    height: 88px;
  }

  .specialTitle {
    -webkit-line-clamp: 1;
  }
}
